import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=5fa54c4e&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,RichText: require('/opt/build/repo/storefront/components/atoms/Text/RichText.vue').default,BaseBanner: require('/opt/build/repo/storefront/components/molecules/Banner/BaseBanner.vue').default})
